/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
function Satisfaction() {
  const navigate = useNavigate();
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '전체', value: 0},
    {title: '3회 만족도', value: 1},
    {title: '7회 만족도', value: 2}
  ];
  return (
    <main className="com_container p_satisfaction">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_16">만족도 설문조사</h2>
          <button onClick={() => navigate('/Student/Satisfaction/Manage')} className="com_btn orange s btn_settings">
            설문 조사 관리
          </button>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">국어</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">영어</label>
                  <input type="radio" name="rdo" id="rdo04" className="com_chk circle" />
                  <label htmlFor="rdo04">수학</label>
                  <input type="radio" name="rdo" id="rdo05" className="com_chk circle" />
                  <label htmlFor="rdo05">과탐</label>
                  <input type="radio" name="rdo" id="rdo06" className="com_chk circle" />
                  <label htmlFor="rdo06">사탐</label>
                  <input type="radio" name="rdo" id="rdo07" className="com_chk circle" />
                  <label htmlFor="rdo07">수시</label>
                  <input type="radio" name="rdo" id="rdo08" className="com_chk circle" />
                  <label htmlFor="rdo08">논술</label>
                </div>
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <section className="com_board_search end">
                <div className="com_btn_wrap">
                  <button className="com_btn line gray s active">오늘</button>
                  <button className="com_btn line gray s">2023</button>
                  <button className="com_btn line gray s">2022</button>
                </div>
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="50" />
                <col width="140" />
                <col width="140" />
                <col width="100" />
                <col width="160" />
                <col width="140" />
                <col width="140" />
                <col width="140" />
                <col width="140" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>발송일</th>
                  <th>학생명</th>
                  <th>과목</th>
                  <th>학부모 전화번호</th>
                  <th>교사</th>
                  <th>담임</th>
                  <th>3회 만족도</th>
                  <th>7회 만족도</th>
                </tr>
              </thead>
              <tbody>
                <tr className="selected">
                  <td>1</td>
                  <td>2022,08,25</td>
                  <td>
                    <button className="btn_link">가길동(남/17)</button>
                  </td>
                  <td>
                    <button className="btn_link">수학</button>
                  </td>
                  <td>
                    <button className="btn_link">010-1234-2134</button>
                  </td>
                  <td>
                    <button className="btn_link">홍길동204</button>
                  </td>
                  <td>
                    <button className="btn_link">김담임101</button>
                  </td>
                  <td>
                    30 <br />
                    2023, 05, 12
                  </td>
                  <td>
                    30 <br />
                    2023, 05, 12
                  </td>
                </tr>
                {[...Array(10)].map((i, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>2022,08,25</td>
                    <td>
                      <button className="btn_link">가길동(남/17)</button>
                    </td>
                    <td>
                      <button className="btn_link">수학</button>
                    </td>
                    <td>
                      <button className="btn_link">010-1234-2134</button>
                    </td>
                    <td>
                      <button className="btn_link">홍길동204</button>
                    </td>
                    <td>
                      <button className="btn_link">김담임101</button>
                    </td>
                    <td>
                      30 <br />
                      2023, 05, 12
                    </td>
                    <td>
                      30 <br />
                      2023, 05, 12
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count">
                <button className="btn_edit" />
              </div>
            </div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="info">
                  <span className="tit">학생명</span>
                  <span className="cont">
                    <button className="name btn_link">홍길동103 </button>
                    (고3ㆍ경기고등학교ㆍ본사)
                  </span>
                </div>
                <div className="info">
                  <span className="tit">연락처</span>
                  <div className="cont">
                    <p className="txt">010-1234-233</p>
                  </div>
                </div>
                <div className="info">
                  <span className="tit">학부모 연락처</span>
                  <div className="cont">
                    <p className="txt">010-1234-233</p>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 회차 </span>
                  <span className="cont">4/25</span>
                </div>
                <div className="info">
                  <span className="tit">최근 진행 수업일시</span>
                  <span className="cont">2023, 05, 10 ㅣ 12:30</span>
                </div>
                <div className="info">
                  <span className="tit">교사</span>
                  <span className="cont">김교사320</span>
                </div>
                <div className="info">
                  <span className="tit">담임</span>
                  <span className="cont">김담임123</span>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">수업 방법</span>
                  <span className="cont">대면</span>
                </div>
                <div className="info">
                  <span className="tit">수업 과목</span>
                  <span className="cont">과탐 / 사회문화, 경제, 밥과정서</span>
                </div>
                <div className="info">
                  <span className="tit">기수 / 타임</span>
                  <span className="cont">2기 / 1T</span>
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">3회 만족도 조사 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                </div>
                <div className="info scroll">
                  1. 기출수능 분석을 통한 문제푸는 방법 확인 <br />
                  2. ERS 출제 가능한 문학 작품 정리 <br />
                  3. 비문학 구조, 문학 중요 개념 등 정리
                </div>
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">김관리102 </button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                  <div className="btn_wrap">
                    <button className="btn_edit"></button>
                    <button className="btn_delete"></button>
                  </div>
                </div>
                <hr className="com_divider" />
                <div className="info">수고 하셨습니다.</div>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_comment_wrap">
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder="김담임 답변하기" />
                <button className="com_btn gray l">등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default Satisfaction;
